import { taggedTemplateLiteral as _taggedTemplateLiteral } from '../../../../_virtual/_rollupPluginBabelHelpers.js';
import styled from 'styled-components';
import { OPEN_END_SIZE_TOKENS } from '../constants.js';

var _templateObject, _templateObject2, _templateObject3, _templateObject4;
var Rail = styled.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  background: ", ";\n  border-radius: ", ";\n"])), function (_ref) {
  var theme = _ref.theme;
  return theme.colours.canvas.primary.main;
}, function (_ref2) {
  var theme = _ref2.theme;
  return theme.borderRadius.primary;
});
var OpenEnd = styled(Rail)(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  width: ", ";\n"])), function (_ref3) {
  var theme = _ref3.theme;
  return theme.sizing[OPEN_END_SIZE_TOKENS.WIDTH];
});
var RailBackground = styled(Rail)(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  flex-grow: 1;\n"])));
var RailContainer = styled.div(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n  display: flex;\n  height: ", ";\n  justify-content: space-between;\n  gap: ", ";\n  position: absolute;\n  transform: ", ";\n\n  ", " {\n    background: ", ";\n  }\n"])), function (_ref4) {
  var theme = _ref4.theme;
  return theme.sizing.tiny;
}, function (_ref5) {
  var theme = _ref5.theme;
  return theme.sizing[OPEN_END_SIZE_TOKENS.GAP];
}, function (_ref6) {
  var theme = _ref6.theme;
  return "translateY(".concat(theme.sizing.xtiny, ")");
}, Rail, function (_ref7) {
  var $selected = _ref7.$selected,
    theme = _ref7.theme;
  return $selected && theme.colours["interface"].main;
});

export { OpenEnd, RailBackground, RailContainer };
//# sourceMappingURL=Rail.styles.js.map
